'use client';

import { Button, CircularProgress } from '@mui/material';

import { actionButtonSx } from '@/styles';

export interface ActionButtonProps {
  label: string;
  loadingLabel: string;
  isLoading: boolean;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

/**
 * Reusable action button with loading state.
 * Use for form actions like "Save changes", "Update password", etc.
 */
export function ActionButton({
  label,
  loadingLabel,
  isLoading,
  disabled,
  onClick,
  type = 'button',
}: ActionButtonProps) {
  return (
    <Button
      type={type}
      variant="outlined"
      fullWidth
      disabled={disabled ?? isLoading}
      onClick={onClick}
      sx={actionButtonSx}
    >
      {isLoading ? (
        <>
          <CircularProgress size={20} sx={{ color: 'inherit', mr: 1.5 }} />
          {loadingLabel}
        </>
      ) : (
        label
      )}
    </Button>
  );
}
